import React from 'react'
import { Outlet, useLocation, Navigate } from 'react-router-dom'
import { Box } from '@mui/material'
import { useSelector } from 'react-redux'
import { RootState } from 'src/store'
import { routeUrls } from 'src/utils/constants'
import PageLoader from '../PageLoader'

const LoginLayout = () => {
  const { isAuthenticated, userInfo, token } = useSelector((state: RootState) => state.auth)
  const location = useLocation()

  if (isAuthenticated === true && userInfo && token) {
    return <Navigate to={routeUrls.home} state={{ from: location }} />
  }

  return (
    <Box p={2} display='flex' height='100vh' alignItems='center' justifyContent='center'>
      <Outlet />
      <PageLoader />
    </Box>
  )
}

export default LoginLayout
